<template>
    <div :style="styleClass">
        {{text}}
    </div>
</template>

<script>
export default {
    name: 'Message',
    /**
     * Входные данные компонента
     * @property {object} styleClass - стиль сообщения
     * @property {string} text - текст ошибки
     */
    props: {
        styleClass: {
            type: Object,
            default: () => ({
                color: '#fff',
                background: '#f24680',
                padding: '5px 0 5px 20px',
                margin: '5px 0 5px 0',
                'border-radius': '10px'
            }) 
        },
        text: {
            type: String,
            default: ""
        }
    }
}
</script>